import {
  createResource,
  getResource,
  postResource,
} from '@/js/resource/resource'

import { DOCUMENT } from './paths'

export const documentListResource = createResource(
  DOCUMENT.LIST, getResource
)

export const groupContractCreateResource = createResource(
  DOCUMENT.CONTRACT_CREATE, postResource
)

export const contractPendingResource = createResource(
  DOCUMENT.CONTRACT_PENDING,
  getResource
)

export const contractAcceptResource = createResource(
  DOCUMENT.CONTRACT_ACCEPT,
  postResource
)